import debug from 'debug';

// ACHTUNG: Nur in shared Ordner verwenden, recruiter/support/user sollen eigene debuggers haben
const actionDebug = debug('USER:action');
const apiDebug = debug('USER:api');
const componentDebug = debug('USER:component');
const routeDebug = debug('USER:route');
export { actionDebug, apiDebug, componentDebug, routeDebug };
